import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions';
import { getUserPermissions } from 'dashboard/helper/permissionsHelper';
import wootConstants from 'dashboard/constants/globals';

class AudioNotificationStore {
  constructor(store) {
    this.store = store;
  }

  hasUnreadConversation = () => {
    const mineConversation = this.store.getters.getMineChats({
      assigneeType: 'me',
      status: 'open',
    });

    return mineConversation.some(conv => conv.unread_count > 0);
  };

  isMessageFromPendingConversation = (message = {}) => {
    const { conversation_id: conversationId } = message || {};
    if (!conversationId) return false;

    const activeConversation =
      this.store.getters.getConversationById(conversationId);
    return activeConversation?.status === wootConstants.STATUS_TYPE.PENDING;
  };

  isConversationSelected = conversationId => {
    return this.store.getters.getSelectedChat?.id === conversationId;
  };

  isConversationLoaded = conversationId => {
    return Boolean(this.store.getters.getConversationById(conversationId));
  };

  // Known to be resolved, snoozed or pending. A conversation not loaded in
  // this view (another inbox or filter) isn't treated as closed.
  isConversationClosed = conversationId => {
    const conversation = this.store.getters.getConversationById(conversationId);
    return Boolean(
      conversation && conversation.status !== wootConstants.STATUS_TYPE.OPEN
    );
  };

  // Someone else on the team has picked up and replied to this chat.
  isAnsweredByAnotherAgent = (conversationId, userId) => {
    const conversation = this.store.getters.getConversationById(conversationId);
    if (!conversation?.first_reply_created_at) return false;
    return conversation.meta?.assignee?.id !== userId;
  };

  isMessageFromCurrentConversation = message => {
    return this.store.getters.getSelectedChat?.id === message.conversation_id;
  };

  hasConversationPermission = user => {
    const currentAccountId = this.store.getters.getCurrentAccountId;
    // Get the user permissions for the current account
    const userPermissions = getUserPermissions(user, currentAccountId);
    // Check if the user has the required permissions
    const hasRequiredPermission = [...ROLES, ...CONVERSATION_PERMISSIONS].some(
      permission => userPermissions.includes(permission)
    );
    return hasRequiredPermission;
  };
}

export default AudioNotificationStore;
